import { Tooltip } from 'antd';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';

export default function SharePriceChart(props) {
  const { data = [], color = '#DD0D33' } = props;
  return (
    <ResponsiveContainer height={'100%'} width={'100%'}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='5%' stopColor={color} stopOpacity={0.8} />
            <stop offset='95%' stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Tooltip />
        <Area type='linear' dataKey='price' stroke={color} fillOpacity={1} fill='url(#colorUv)' />
      </AreaChart>
    </ResponsiveContainer>
  );
}
